import React from 'react';
import { setCurrentView } from 'core/utils';
import { EditOrderViewStore } from 'modules/order/stores';
import { EditOrderTemplate } from 'themes/modules/order/pages';

@setCurrentView((rootStore, componentProps) => new EditOrderViewStore(rootStore, componentProps), 'editOrderViewStore')
class EditOrder extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <EditOrderTemplate {...this.props} />;
	}
}

export default EditOrder;



// WEBPACK FOOTER //
// ./src/modules/order/pages/EditOrder.jsx